module.exports = __webpack_public_path__ + "static/media/icon_HTML_W.4171c8a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_HTML_W.svg
// module id = 1941
// module chunks = 0